export const makeShowLink = (date, multiShowIndex) => {
   return multiShowIndex
    ? `/shows/${date.substr(0,10)}/${multiShowIndex}`
    : `/shows/${date.substr(0,10)}`
};